import { Mail, Phone, MapPin } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="h-12 w-[72px] mb-4">
              <picture>
                <source srcSet="/logo-384.webp" type="image/webp" />
                <img
                  src="/logo-384.png"
                  alt="LocationOran.com"
                  width={72}
                  height={48}
                  className="h-12 w-auto object-contain brightness-0 invert"
                />
              </picture>
            </div>
            <p className="text-gray-300">
              Location à Oran : appartements, villas, hotels et voitures.
              Réservez votre hébergement et location nuitée à Oran, Algérie.
              Best hotels in Oran, cheap hotels, luxury accommodation.
            </p>
            <div className="mt-4 text-sm text-gray-400">
              <p>Location appartement Oran | Villa Oran | Hotel Oran</p>
              <p>Location voiture Oran | Activités Oran</p>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center text-gray-300">
                <Phone size={18} className="mr-3" />
                <span>0776043917</span>
              </div>
              <div className="flex items-center text-gray-300">
                <Mail size={18} className="mr-3" />
                <span>dev@softalgeria.com</span>
              </div>
              <div className="flex items-center text-gray-300">
                <MapPin size={18} className="mr-3" />
                <span>Oran, Algérie</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="text-center text-gray-400 mb-4">
            <p className="text-xs">
              Location Oran, Appartement Oran, Villa Oran, Hotel Oran, Location Voiture Oran, Nuitée Oran,
              Louer à Oran, Hotels in Oran, Oran Accommodation, Best Hotels in Oran, Luxury Hotel Oran,
              Cheap Hotels in Oran, Beach Hotel Oran, Oran Algeria Hotel, Oran Lodging, Hostel Oran,
              Activités Oran, Location Voitures Oran, Réserver un Hotel à Oran, Oran City Center Hotel
            </p>
          </div>
          <p className="text-center text-gray-300">&copy; {new Date().getFullYear()} LocationOran.com - Tous droits réservés</p>
        </div>
      </div>
    </footer>
  );
}
